import React from 'react'

const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']

export default ({date}) => (
  <span>
    {date.getFullYear()}.{date.getMonth() + 1}.{date.getDate()}&nbsp;{days[date.getDay()]}
  </span>
)



// WEBPACK FOOTER //
// ./src/components/PrettyDate.js